import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button<{ variant?: 'default' | 'outline' }>`
  background-color: var(--color-black);
  color: var(--color-white);
  border: 2px solid var(--color-black);
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 0;
  
  &:hover {
    background-color: var(--color-white);
    color: var(--color-black);
  }
  
  &:disabled {
    background-color: var(--color-gray);
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  ${props => props.variant === 'outline' && `
    background-color: var(--color-white);
    color: var(--color-black);
    
    &:hover {
      background-color: var(--color-black);
      color: var(--color-white);
    }
  `}
`;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline';
  asChild?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'default', asChild, children, ...props }, ref) => {
    if (asChild && React.isValidElement(children)) {
      return React.cloneElement(children, {
        ...props,
        className: `${children.props.className || ''} ${props.className || ''}`.trim()
      } as any);
    }
    
    return (
      <StyledButton ref={ref} variant={variant} {...props}>
        {children}
      </StyledButton>
    );
  }
);

Button.displayName = 'Button';
